import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Page from '../../../components/common/Page/Page';
import GetInTouch from '../../../components/Get-In-Touch/Get-In-Touch';
import { addCrumbs } from '../../../redux/breadcrumb.reducer';
import { ROUTES } from '../../../constants/routes';
import './ServiceDetails.scss';
import certificationData from '../../../data/legal-for-trade.json';
import maintenanceData from '../../../data/preventive-maintenance.json';
import repairData from '../../../data/repair.json';
import technicalSupportData from '../../../data/technical.json';

const SERVICE_JSON_MAP = {
  certification: certificationData,
  maintenance: maintenanceData,
  repair: repairData,
  'technical-support': technicalSupportData,
};

const ServiceDetails = () => {
  const { serviceType } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);

  useEffect(() => {
    const jsonData = SERVICE_JSON_MAP[serviceType];
    setData(jsonData);
    if (jsonData) {
      dispatch(addCrumbs([
        { label: 'Services', link: ROUTES.SERVICES },
        { label: jsonData.title, link: `/services/${serviceType}` }
      ]));
    }
  }, [serviceType, dispatch]);

  if (!data) return <div>Service not found.</div>;

  return (
    <>
      <Page className="service-details" title={data.title} subTitle={data.subtitle} backButtonLabel={'All Services'}>
        {data.sections.map((section, idx) => (
          <div key={idx} className="service-section">
            <h3>{section.icon} {section.heading}</h3>
            <p>{section.content}</p>
            {section.bullet_points && (
              <ul>
                {section.bullet_points.map((point, i) => <li key={i}>{point}</li>)}
              </ul>
            )}
            {section.items_with_icons && (
              <ul>
                {section.items_with_icons.map((item, i) => (
                  <li key={i}>{item.icon} {item.label}</li>
                ))}
              </ul>
            )}
            {section.link && (
              <p><a href={section.link.url} target={section.link.target || "_blank"} rel="noopener noreferrer">{section.link.text}</a></p>
            )}
            {section.contact_info && (
              <div>
                {section.contact_info.phone && <p><b>Phone:</b> <a href={`tel:${section.contact_info.phone}`}>{section.contact_info.phone}</a></p>}
                {section.contact_info.email && <p><b>Email:</b> <a href={`mailto:${section.contact_info.email}`}>{section.contact_info.email}</a></p>}
              </div>
            )}
            {section.note && <p><i>{section.note}</i></p>}
          </div>
        ))}
      </Page>
      <div style={{ width: '100%' }}>
        <GetInTouch />
      </div>
    </>
  );
};

export default ServiceDetails;
